import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { combineLatest, Observable, Subject } from 'rxjs';
import { filter, map, takeUntil, tap } from 'rxjs/operators';
import { ApiService } from 'src/app/api.service';
import { CLASS_MODE } from 'src/app/constants';
import { HelperService } from 'src/app/helper.service';
import { isNil } from 'src/app/utils';
import { IFilterParams } from '../interface';

@Component({
  selector: 'app-search-filters',
  templateUrl: './search-filters.component.html',
  styleUrls: ['./search-filters.component.scss']
})
export class SearchFiltersComponent implements OnInit {

  @Output('onApplyFilters') onApplyFilters = new EventEmitter<IFilterParams>()

  destroy$ = new Subject<boolean>();
  filterParams: IFilterParams = {};

  searchForm: FormGroup

  serviceTypeList$: Observable<any[]>
  specialityList$: Observable<any[]>
  specialityCategoryList$: Observable<any[]>

  modeList = CLASS_MODE;

  constructor(
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private helper: HelperService,
    private apiService: ApiService,
  ) { 
    const categoryId = this.activatedRoute.snapshot.paramMap.get('category');
    const specialityId = this.activatedRoute.snapshot.paramMap.get('specialityId');

    this.searchForm = this.fb.group({
      categoryId: [categoryId, Validators.required],
      specialityId: [specialityId || ''],
      mode: ['']
    })

    this.filterParams = {categoryId, specialityId: specialityId || ''}


    combineLatest([this.activatedRoute.queryParams, this.helper.searchLocationOb$])
    .pipe(
      takeUntil(this.destroy$)
    ).subscribe(([param1, param2]) => {
      if (!isNil(param1.mode)) {
        this.filterParams.mode = param1.mode;
        this.mode.setValue(param1.mode)
      }
      if (!!param2) {
        this.filterParams.location = param2
      }
    })
  }

  get categoryId() {
    return this.searchForm.get('categoryId');
  }
  get specialityId() {
    return this.searchForm.get('specialityId');
  }
  get mode() {
    return this.searchForm.get('mode');
  }

  ngOnInit(): void {
    setTimeout(() => this.applyFilters(), 100)

    this.serviceTypeList$ = this.apiService.getVenDetails({})
      .pipe(
        map((el: any) => el.data.venDetails.data),
        tap(() => this.onCategoryChange(false))
      )

    this.specialityCategoryList$ = this.apiService.getSpecialityCategory({}) as Observable<any[]>;
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  applyFilters() {
    this.filterParams = {...this.filterParams, ...this.searchForm.value}
    this.onApplyFilters.emit(this.filterParams);
  }

  onCategoryChange(resetSpecility: boolean) {
    if(resetSpecility) this.specialityId.setValue('');
    this.specialityList$ = this.apiService.getspetialityDetails({ vendorType: this.categoryId.value })
      .pipe(
        map((el: any) => el.data.venSplDetails.data)
      )
  }

  handleAddressChange(address: Address) {
    this.helper.setSearchLocation(address);
    this.filterParams.location = address;
  }

}
